<template>
  <div>
    <LazySignModal v-if="showLegalModal" />
    <slot />
  </div>
</template>

<script>
import { LazySignModal } from '#components'
import { mapActions, mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import { useAppAnalyticsStore } from '~/store/app-analytics'
import { useBorrowerStore } from '~/store/borrower'
import { useRootStore } from '~/store/root'
import { useUserStore } from '~/store/user'
import { get } from 'es-toolkit/compat'
/**
 * Include this component in any new vue layouts (excluding legacy)
 * Add any shared code here that should exist in all layouts
 */
export default {
  components: {
    LazySignModal,
  },
  async setup () {
    const rootStore = useRootStore()
    const affiliateCustomizationsStore = useAffiliateCustomizationStore()
    const analyticsStore = useAppAnalyticsStore()
    const borrowerStore = useBorrowerStore()
    const { showLegalModal } = storeToRefs(borrowerStore)
    rootStore.setPageTitle(affiliateCustomizationsStore.headTitlePrefix + ' - Portal')

    rootStore.setLendioFavicons()

    useHead({
      title: rootStore.pageTitle,
      link: rootStore.favicons,
    })

    return {
      showLegalModal,
      analyticsStore,
    }
  },
  watch: {
    '$route.path'() {
      this.analyticsStore.dreamsSetEvent({ name: this.$route.path, value: true })
    },
  },
  props: {
    gtm: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState(useRootStore, [
      'pageTitle',
    ]),
    ...mapState(useRootStore, {
      authUser: (store) => store.authUser
    }),
    ...mapState(useBorrowerStore, {
      borrower: state => get(state, 'borrower', null),
      borrowerId: state => get(state, 'borrowerId', null),
    }),
    lendioId() {
      return get(window, 'dreams.dataLayer.user.lendioId', null)
    },
  },
  methods: {
    ...mapActions(useRootStore, [
      'setPageTitle',
      'setLendioFavicons',
      'setBlankFavicons'
    ]),
  },

  async mounted() {
    const userStore = useUserStore()
    await userStore.loadFreshLogin()
  },
}
</script>

<style lang="scss">

.btn.btn-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(5, 194, 240, 0.5) !important;
}
.btn.btn-primary.next-save {
  box-shadow: none !important;
}
</style>
